<template>
  <div
    class="fill-height of-y"
    @scroll="scrollTop = $el.scrollTop"
    style="overflow-x: hidden"
  >

    <div v-if="startingUp" class="fill-height d-flex flex-grow-1 of-y align-center justify-center flex-column">
      <img alt="logo" src="images/logo_full_dark-01.svg" height="80" class="pr-2"/>
      <v-progress-circular
        class="mt-10"
        :size="80"
        :width="2"
        color="primary"
        indeterminate
      />
    </div>

    <div v-else-if="!authorized" class="fill-height d-flex align-center justify-center flex-grow-1">
      <img alt="logo" src="images/locked_device.svg" height="600" class="pr-2"/>
    </div>

    <template v-else>
      <div style="position: sticky; top: 0; z-index: 99" class="d-flex align-center justify-space-between pa-2" :class="{
                'elevation-5': !!scrollTop
            }" :style="{
                'background': !!scrollTop ? '#131313' : '#121212'
            }">
        <!--                <div class="d-flex align-center">-->
        <div class="d-flex align-center" >
          <img alt="logo" src="images/watch_dark-01.svg" height="40" class="pr-2"/>
          <img alt="logo" src="images/text_only_no_subtext_white-01.svg" height="30" class="pr-2"/>
        </div>
<!--                    <div style="line-height: 1; white-space: nowrap" >-->
<!--                        <div style="line-height: 1" class="text-h5">-->
<!--                            {{employeeName}}-->
<!--                        </div>-->
<!--                        <div style="line-height: 1" v-if="curDevice && curDevice.hostname" class="caption mt-1">-->
<!--                            {{team.name}} - {{curDevice && curDevice.hostname }}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

        <app-nav-bar-tabs v-model="selectedTab" :tabs="tabs"/>

        <div class="d-flex align-center">
          <!--                              <div v-if="employeeName && team" style="line-height: 1; white-space: nowrap" class="caption text-end pb-1" >-->
          <!--                                  {{team.name}} - <strong>{{employeeName}}</strong>-->
          <!--                              </div>-->
          <div class="text-end d-flex align-center">

            <v-btn
              icon
              color="primary"
              class="mx-2"
              @click="previousDay"
              :disabled="selectedTab === 2"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              :disabled="selectedTab === 2"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  small
                  outlined
                  v-on="on"
                  :disabled="selectedTab === 2"
                >
                  <v-icon small left>mdi-calendar</v-icon>
                  {{ dateTitle }}
                </v-btn>
              </template>

              <v-card class="lightSurface">
                <div class="d-flex">
                  <v-date-picker
                    v-if="!resetDtPicker"
                    v-model="dates"
                    range
                    no-title
                    scrollable
                    :max="maxDate"
                    :first-day-of-week="1"
                    flat
                    color="primary"
                    format="24hr"
                  />
                  <div class="d-flex flex-column justify-space-around">
                    <template v-for="filter in filters">
                      <v-btn
                        :key="filter.title"
                        color="primary"
                        text
                        small
                        @click="setDates(filter.cb(filter.title))"
                      >
                        {{filter.title}}
                      </v-btn>
                    </template>
                  </div>
                </div>
                <v-divider></v-divider>
                <v-card-actions class="d-flex justify-end">
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    color="secondary"
                    @click="dateMenu = false"
                  >
                    Done
                  </v-btn>
                </v-card-actions>
              </v-card>

            </v-menu>

            <v-btn
              icon
              color="primary"
              class="mx-2"
              @click="nextDay"
              :disabled="isRangeStartToday || selectedTab === 2"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>


          <div style="line-height: 1; white-space: nowrap" class="ml-5">
            <div style="line-height: 1" class="text-h5 text-end">
              {{employeeName}}
            </div>
            <div style="line-height: 1" v-if="curDevice && curDevice.hostname" class="caption text-end mt-1">
              {{team.name}} - {{curDevice && curDevice.hostname }}
            </div>
          </div>
        </div>

      </div>

      <div class="d-flex align-center justify-center" v-if="loading">
        <v-progress-circular
          class="mt-10"
          :size="80"
          :width="2"
          color="primary"
          indeterminate
        />
      </div>

      <template v-else>

        <v-scroll-x-transition hide-on-leave>
          <div v-if="selectedTab === 0" key="stats">
            <v-scroll-y-transition hide-on-leave>
              <div key="data" v-if="stats.summary">
                <!--Statistics-->
                <div class="text-h5 px-10 pt-4 font-weight-light">Statistics</div>
                <v-scroll-y-transition hide-on-leave>
                  <div class="d-flex align-start justify-space-around flex-wrap px-10 pt-4">
                    <template v-for="card in shownCards">
                      <v-card class="mb-4 mx-2" width="300" :key="card.key" style="position: relative">

                        <div class="pa-2 grey--text" style="position: absolute; right: 0; top: 0">
                          {{ card.valDesc }}
                        </div>

                        <div class="pa-2">
                          <div class="body-2">
                            {{ card.info.text }}
                          </div>
                          <div class="caption grey--text">
                            {{ card.info.description }}
                          </div>
                        </div>

                        <div class="px-4 pb-2 text-h5 text-end">
                          {{ card.val }}
                        </div>
                        <div>
                          {{ card.val2 }}
                        </div>
                      </v-card>
                    </template>
                  </div>
                </v-scroll-y-transition>
                <!--Time Performance-->
                <div class="text-h5 px-10 pt-4 font-weight-light">Time / Activity Breakdown</div>
                <v-scroll-y-transition hide-on-leave>
                  <div style="width: 100%; max-height: 500px" class="px-12 pt-4">
                    <apex-chart height="300" type="line" :options="timePerformanceChartData.chartOptions"
                                :series="timePerformanceChartData.series"></apex-chart>
                  </div>
                </v-scroll-y-transition>
                <!--Breakdown-->
                <template v-if="dateDays !== 0">
                  <div class="text-center overline amber--text px-10 pt-4">Breakdown is only available for a single day</div>
                </template>
                <template v-else>
                  <div class="text-h5 px-10 pt-4 font-weight-light">App Usage Breakdown</div>
                  <v-scroll-y-transition hide-on-leave>
                    <div style="width: 100%; max-height: 500px" class="px-12 pt-4">
                      <v-scroll-x-transition hide-on-leave>
                        <div v-if="loadingBreakdown" style="height: 300px" class="d-flex align-center justify-center">
                          <app-centre-loader label="Loading"></app-centre-loader>
                        </div>
                      </v-scroll-x-transition>
                      <v-scroll-x-transition hide-on-leave>
                        <apex-chart v-if="stats.breakdown && !loadingBreakdown" height="300" type="rangeBar" :options="breakdownChartData.chartOptions"
                                    :series="breakdownChartData.series"></apex-chart>
                      </v-scroll-x-transition>
                    </div>
                  </v-scroll-y-transition>
                </template>
                <!--Top Apps & Productivity Distribution -->
                <v-scroll-y-transition hide-on-leave>
                  <div class="d-flex justify-center fill-height flex-grow-1 flex-equal "
                       style="min-width: 500px">
                    <div class="flex-grow-1 flex-equal">
                      <div class="text-h5 px-10 pt-4 font-weight-light">Top Apps</div>
                      <div class="d-flex justify-center">
                        <apex-chart style="width: 70%"  type="donut" :options="topAppsChartData.chartOptions"
                                    :series="topAppsChartData.seriesData"></apex-chart>
                      </div>

                    </div>
                    <div class="flex-grow-1 flex-equal">
                      <div class="text-h5 px-10 pt-4 font-weight-light">Productivity Distribution</div>
                      <div class="d-flex justify-center">
                        <apex-chart style="width: 70%" type="radialBar" :options="productivityChartData.chartOptions"
                                    :series="productivityChartData.seriesData"></apex-chart>
                      </div>

                    </div>
                  </div>
                </v-scroll-y-transition>
                <!--Top Apps Detail -->
                <div class="text-h5 px-10 pt-4 pb-2 font-weight-light">Top Apps Detail</div>
                <v-scroll-y-transition hide-on-leave>
                  <div class="d-flex justify-center">

                    <v-card style="width: 90%; max-width: 1000px; min-width: 300px">
                      <v-data-table
                        :headers="topAppTableHeaders"
                        :items="stats.topApps"
                        :items-per-page="stats.topApps.length"
                        hide-default-footer
                        :sortBy.sync="$store.state.sortPreference.employeeStats.topApps.by"
                        :sort-desc.sync="$store.state.sortPreference.employeeStats.topApps.order"
                      >
                        <template v-slot:item.match="{ item }">
                          <div class="d-flex align-center overline">
                            <app-icon :match="item.match" left small :site-id="$store.state.employeeDashboard.siteId"/>
                            {{ item.match }}
                          </div>
                        </template>

                        <template v-slot:item.totalDuration="{ item }">{{
                            hourDisplay(item.totalDuration, true)
                          }}
                        </template>
                        <template v-slot:item.label="{ item }">
                          <div class="d-flex align-center">
                            <v-icon small :color="labelsRef[item.label].color" left>
                              {{ labelsRef[item.label].icon }}
                            </v-icon>
                            <div class="body-2 d-flex align-center" :class="`${labelsRef[item.label].color}--text`">{{
                                labelsRef[item.label].text
                              }}
                            </div>
                          </div>
                        </template>

                        <!--                                    <template v-slot:item.actions="{ item }">-->
                        <!--                                        <v-btn-->
                        <!--                                                color="primary"-->
                        <!--                                                class="mx-2"-->
                        <!--                                                small-->
                        <!--                                                icon-->
                        <!--                                                @click.stop="gotoApp(item.match)"-->
                        <!--                                        >-->
                        <!--                                            <v-icon>mdi-cog</v-icon>-->
                        <!--                                        </v-btn>-->
                        <!--                                    </template>-->


                      </v-data-table>
                    </v-card>
                  </div>
                </v-scroll-y-transition>

                <!--Top Apps Detail -->
                <div class="text-h5 px-10 pt-4 font-weight-light">Devices</div>
                <div class="d-flex justify-space-around flex-wrap align-baseline">
                  <template v-for="device in employeeDevices.filter(device => !device.userDevice)">
                    <v-card
                      :key="device._id"
                      v-if="!device.phone && !device.o365TenantUser"
                      class="ma-5"
                      max-width="700"
                      min-width="300"
                    >
                      <v-card-title>
                        {{device.name || device.hostname}}
                      </v-card-title>
                      <v-card-text>
                        <app-device-hardware-info :device="device"></app-device-hardware-info>
                      </v-card-text>

                    </v-card>
                  </template>

                </div>
              </div>

              <div v-else key="noData" class="pa-10">
                <div class="text-overline amber--text text-center">
                  No data for the selected date range
                  <br>
                  Please select another date or range
                </div>
              </div>
            </v-scroll-y-transition>
          </div>
          <div v-if="selectedTab === 1" key="log">
            <v-scroll-y-transition hide-on-leave>
              <div key="manualTimeLoading" class="d-flex align-center justify-center" v-if="manualTimeStarting">
                <v-progress-circular
                    class="mt-10"
                    :size="80"
                    :width="2"
                    color="primary"
                    indeterminate
                />
              </div>
              <div key="manualTime" v-else>
                <div class="text-h5 px-10 pt-4 font-weight-light">Idle Times</div>
                
                <template v-if="dateDays !== 0">
                  <div class="text-center overline amber--text px-10 pt-4 pb-2">Capturing Manual time is only available when a single day is selected</div>
                </template>
                
                <div v-else class="d-flex justify-center">
                  
                  <v-card style="width: 90%; max-width: 1000px; min-width: 300px">
                    
                    <v-card-title class="my-2 py-1 d-flex justify-space-between">
                      {{format(start, "dd MMMM yyyy")}}
                      
                      <v-btn
                          outlined
                          color="primary"
                          :disabled="!selectedStaleTimes.length"
                          small
                          @click="createManualTimeShow = true"
                      >Log Manual Time</v-btn>
                    </v-card-title>
                    
                    
                    <div class="mx-4" style="height: 90px; position: relative">
                      
                      <div
                          style="position: absolute; top: 45px; border-top: 1px solid rgba(255,255,255,0.5); height: 1px; width: 100%; left: 0;"
                      ></div>
                      
                      <template v-for="n in 48">
                        <div
                            class="caption"
                            style="position: absolute; top: 45px;"
                            :style="{
                              'left': `${((n-1)/48) * 100}%`,
                              'width': `${(1/48) * 100}%`,
                              'height': `${(n % 2) === 0 ? '10px' : '15px'}`,
                              'border-left': n === 1 ? 'none' : `1px solid ${(n % 2) === 0 ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.5)'}`
                          }"
                        >
                          <div v-if="n % 2 && n > 1" style="position: absolute; top: 100%; transform: translate(-50%, 0)" class="grey--text">
                            {{((n - 1) / 2).toString().padStart(2, '0')}}:00
                          </div>
                        
                        </div>
                      </template>
                      
                      <template v-if="staleTimes.length > 0">
                        <template v-for="(slot, i) in staleTimes">
                          
                          <v-tooltip top :key="slot.key">
                            <template #activator="{on}">
                              <div
                                  v-on="on"
                                  class="time-sector"
                                  :class="{
                                  'selected': selectedStaleTimes.includes(slot)
                                }"
                                  :style="{
                                  'width': `${(slot.duration / 86400) * 100}%`,
                                  'left': `${(((slot.start.getTime() - startOfDay(range.start).getTime()) / 1000) / 86400) * 100}%`
                                }"
                                  @click.ctrl.stop="addRemoveSelect($event, slot)"
                                  @click.shift.stop="rangeSelect($event, slot)"
                                  @click.exact="arrSplice(selectedStaleTimes, () => true); selectedStaleTimes.push(slot)"
                              >
                              
                              </div>
                            </template>
                            <div>
                              <div>{{ format(slot.start, 'HH:mm') }} - {{ format(slot.end, 'HH:mm') }}</div>
                              <div>{{ hourDisplay(slot.duration, true) }}</div>
                            </div>
                          </v-tooltip>
                        </template>
                      </template>
                      
                      <template v-else>
                        <div
                            class="d-flex justify-center align-center flex-grow-1"
                            style="color: rgba(255, 255, 255, 0.5)"
                        >No data available</div>
                      </template>
                    
                    </div>
                    <v-data-table
                        :headers="staleTimeHeaders"
                        :items="staleTimes"
                        :items-per-page="staleTimes.length"
                        item-key="key"
                        selectable-key="key"
                        show-select
                        hide-default-footer
                        checkbox-color="primary"
                        v-model="selectedStaleTimes"
                    >
                      <template v-slot:item.start="{ item }">{{format(item.start, 'HH:mm')}}</template>
                      
                      <template v-slot:item.end="{ item }">{{format(item.end, 'HH:mm')}}</template>
                      
                      <template v-slot:item.duration="{ item }">{{hourDisplay(item.duration, true)}}</template>
                      
                      <template v-slot:item.declined="{ item }">
                        {{ item }}
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
                
              </div>
            </v-scroll-y-transition>
          </div>
          <div v-if="selectedTab === 2" key="pending">
            <v-scroll-y-transition hide-on-leave>
              <div key="manualTimeLoading" class="d-flex align-center justify-center" v-if="manualTimeStarting">
                <v-progress-circular
                    class="mt-10"
                    :size="80"
                    :width="2"
                    color="primary"
                    indeterminate
                />
              </div>
              <div key="manualTime" v-else>
                <div class="text-h5 px-10 pt-4 pb-2 font-weight-light">Manual Time Approvals</div>
                
                <div class="d-flex justify-center">
                  
                  <v-card style="width: 90%; max-width: 1000px; min-width: 300px">
                    
                    <v-data-table
                        :headers="pendingApprovalHeaders"
                        :items="pendingManualTimesGrouped"
                        :items-per-page="pendingManualTimesGrouped.length"
                        item-key="_id"
                        hide-default-footer
                        show-expand
                        :item-class="getItemClassPending"
                    >
                      <template v-slot:item.match="{ item }">
                        <div :class="doesManualTimeHaveADeclineReason(item) ? 'error--text' : null">{{ item.match }}</div>
                      </template>
                      
                      <template v-slot:item.start="{ item }">
                        <div :class="doesManualTimeHaveADeclineReason(item) ? 'error--text' : null">{{ format(item.start, 'dd MMM yyyy HH:mm') }}</div>
                      </template>
                      
                      <template v-slot:item.end="{ item }">
                        <div :class="doesManualTimeHaveADeclineReason(item) ? 'error--text' : null">{{ format(item.end, 'HH:mm') }}</div>
                      </template>
                      
                      <template v-slot:item.duration="{ item }">
                        <div :class="doesManualTimeHaveADeclineReason(item) ? 'error--text' : null">{{ hourDisplay(item.duration, true) }}</div>
                      </template>
                      
                      <template v-slot:item.declined="{ item }">
                        <div :class="{ 'error--text': item.declined }">{{ item.declined ? 'Declined' : 'Pending' }}</div>
                      </template>
                      
                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                          <div
                              class="pa-3"
                              style="overflow: visible"
                          >
                            <div
                                class="pt-3"
                                style="overflow: visible"
                            >
                              <div class="text-body-2 px-3 pb-3" style="height: auto !important;" v-if="item.hasDeclinedReason">
                                <strong class="error--text">Declined Reason</strong>: {{ item.declinedReason }}
                              </div>
                              
                              <div class="text-body-2 px-3 pb-3" style="height: auto !important;" v-if="item.hasMotivation">
                                <strong class="success--text">Motivation</strong>: {{ item.motivation }}
                              </div>
                              
                              <div class="px-3 pb-3">
                                <v-simple-table v-if="item.members.length > 1" class="text-caption">
                                  <thead>
                                  <tr style="height: auto !important;">
                                    <th class="text-left py-1" style="height: auto !important;">
                                      Start
                                    </th>
                                    <th class="text-left py-1" style="height: auto !important;">
                                      End
                                    </th>
                                    <th class="text-left py-1" style="height: auto !important;">
                                      Duration
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr
                                      v-for="member in item.members"
                                      :key="member._id"
                                      style="height: auto !important;"
                                  >
                                    <td class="text-caption py-1" style="height: auto !important;">
                                      {{format(new Date(member.start), 'HH:mm')}}
                                    </td>
                                    <td class="text-caption py-1" style="height: auto !important;">
                                      {{format(new Date(member.end), 'HH:mm')}}
                                    </td>
                                    <td class="text-caption py-1" style="height: auto !important;">
                                      {{hoursDisplay(member.duration)}}
                                    </td>
                                  </tr>
                                  </tbody>
                                </v-simple-table>
                              </div>
                            
                            
                            </div>
                          </div>
                        </td>
                      </template>
                    
                    </v-data-table>
                  </v-card>
                </div>
              </div>
            </v-scroll-y-transition>
          </div>
          
          <div v-if="selectedTab === 3" key="declined">
            <v-scroll-y-transition hide-on-leave>
              <div key="manualTimeLoading" class="d-flex align-center justify-center" v-if="manualTimeStarting">
                <v-progress-circular
                    class="mt-10"
                    :size="80"
                    :width="2"
                    color="primary"
                    indeterminate
                />
              </div>
              <div key="manualTime" v-else>
                <div class="text-h5 px-10 pt-4 pb-2 font-weight-light">Manual Time Approvals</div>
                
                <div class="d-flex justify-center">
                  
                  <v-card style="width: 90%; max-width: 1000px; min-width: 300px">
                    
                    <v-data-table
                        :headers="declinedHeaders"
                        :items="declinedManualTimesGrouped"
                        :items-per-page="declinedManualTimesGrouped.length"
                        item-key="_id"
                        hide-default-footer
                        show-expand
                        :item-class="getItemClassPending"
                    >
                      <template v-slot:item.match="{ item }">
                        <div :class="doesManualTimeHaveADeclineReason(item) ? 'error--text' : null">{{ item.match }}</div>
                      </template>
                      
                      <template v-slot:item.start="{ item }">
                        <div :class="doesManualTimeHaveADeclineReason(item) ? 'error--text' : null">{{ format(item.start, 'dd MMM yyyy HH:mm') }}</div>
                      </template>
                      
                      <template v-slot:item.end="{ item }">
                        <div :class="doesManualTimeHaveADeclineReason(item) ? 'error--text' : null">{{ format(item.end, 'HH:mm') }}</div>
                      </template>
                      
                      <template v-slot:item.duration="{ item }">
                        <div :class="doesManualTimeHaveADeclineReason(item) ? 'error--text' : null">{{ hourDisplay(item.duration, true) }}</div>
                      </template>
                      
                      <template v-slot:item.declined="{ item }">
                        <div :class="{ 'error--text': item.declined }">{{ item.declined ? 'Declined' : 'Pending' }}</div>
                      </template>
                      
                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                          <div
                              class="pa-3"
                              style="overflow: visible"
                          >
                            <div
                                class="pt-3"
                                style="overflow: visible"
                            >
                              <div class="text-body-2 px-3 pb-3" style="height: auto !important;" v-if="item.hasDeclinedReason">
                                <strong class="error--text">Declined Reason</strong>: {{ item.declinedReason }}
                              </div>
                              
                              <div class="text-body-2 px-3 pb-3" style="height: auto !important;" v-if="item.hasMotivation">
                                <strong class="success--text">Motivation</strong>: {{ item.motivation }}
                              </div>
                              
                              <div class="px-3 pb-3">
                                <v-simple-table v-if="item.members.length > 1" class="text-caption">
                                  <thead>
                                  <tr style="height: auto !important;">
                                    <th class="text-left py-1" style="height: auto !important;">
                                      Start
                                    </th>
                                    <th class="text-left py-1" style="height: auto !important;">
                                      End
                                    </th>
                                    <th class="text-left py-1" style="height: auto !important;">
                                      Duration
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr
                                      v-for="member in item.members"
                                      :key="member._id"
                                      style="height: auto !important;"
                                  >
                                    <td class="text-caption py-1" style="height: auto !important;">
                                      {{format(new Date(member.start), 'HH:mm')}}
                                    </td>
                                    <td class="text-caption py-1" style="height: auto !important;">
                                      {{format(new Date(member.end), 'HH:mm')}}
                                    </td>
                                    <td class="text-caption py-1" style="height: auto !important;">
                                      {{hoursDisplay(member.duration)}}
                                    </td>
                                  </tr>
                                  </tbody>
                                </v-simple-table>
                              </div>
                            
                            
                            </div>
                          </div>
                        </td>
                      </template>
                    
                    </v-data-table>
                  </v-card>
                </div>
              </div>
            </v-scroll-y-transition>
          </div>
        </v-scroll-x-transition>

        
      </template>
    </template>
    <!-- Log Manual Time Dialog -->
    <app-dlg
      v-if="createManualTimeShow"
      :show-dlg.sync="createManualTimeShow"
      title="Log Manual Time"
      :default-padding="false"
    >

      <template>
        <!--Multiple-->
        <div v-if="selectedStaleTimes.length > 1">
          <div class="caption px-3">
            Selected Idle Times
          </div>
          <div >
            <v-data-table
              :headers="staleTimeHeaders"
              :items="selectedStaleTimes"
              :items-per-page="selectedStaleTimes.length"
              item-key="key"
              hide-default-footer
              style="max-height: 300px"
              class="of-y"
              dense
            >
              <template v-slot:item.start="{ item }">{{format(item.start, 'HH:mm')}}</template>
              <template v-slot:item.end="{ item }">{{format(item.end, 'HH:mm')}}</template>
              <template v-slot:item.duration="{ item }">{{hourDisplay(item.duration, true)}}</template>
            </v-data-table>
          </div>
        </div>
        <!--Single-->
        <div v-else>
          <div>
            <v-menu
              ref="menu"
              v-model="singleIdleRangeSelector.startShown"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="singleIdleRangeSelector.start"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="singleIdleRangeSelector.start"
                  label="Start"
                  prepend-icon="mdi-clock-start"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  class="mx-3"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="singleIdleRangeSelector.startShown"
                v-model="singleIdleRangeSelector.start"
                full-width
                @click:minute="$refs.menu.save(singleIdleRangeSelector.start)"
                :max="singleIdleRangeSelector.end"
                :min="singleIdleRangeSelector.min"
                color="primary"
                format="24hr"
              ></v-time-picker>
            </v-menu>
            <v-menu
              ref="menuEnd"
              v-model="singleIdleRangeSelector.endShown"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="singleIdleRangeSelector.end"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="singleIdleRangeSelector.end"
                  label="End"
                  prepend-icon="mdi-clock-end"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  class="mt-2 mx-3"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="singleIdleRangeSelector.endShown"
                v-model="singleIdleRangeSelector.end"
                full-width
                @click:minute="$refs.menuEnd.save(singleIdleRangeSelector.end)"
                :min="singleIdleRangeSelector.start"
                :max="singleIdleRangeSelector.max"
                color="primary"
                format="24hr"
              ></v-time-picker>
            </v-menu>

            <v-text-field
              :value="hourDisplay(
                differenceInSeconds(new Date(format(new Date(), 'yyyy-MM-dd') + ' ' + singleIdleRangeSelector.end), new Date(format(new Date(), 'yyyy-MM-dd') + ' ' + singleIdleRangeSelector.start)))"
              label="Duration"
              prepend-icon="mdi-timer"
              readonly
              hide-details
              class="mt-2 mx-3"
            ></v-text-field>
          </div>
        </div>

        <v-autocomplete
          return-object
          label="Reason"
          class="mt-2 mx-3"
          item-text="match"
          item-value="match"
          prepend-icon="mdi-tag"
          :items="manualTimeOptions"
          v-model="selectedManualTimeOption"
          :rules="[validationRules.required]"
        ></v-autocomplete>

        <v-textarea
          v-if="selectedManualTimeOption ? selectedManualTimeOption.manualTimeMotivation : false"
          outlined
          auto-grow
          :rows="3"
          class="mt-2 mx-3"
          label="Motivation"
          ref="employeeInput"
          prepend-icon="mdi-message-text"
          v-model="employeeManualTimeMotivation"
          :rules="[validationRules.required]"
        ></v-textarea>

      </template>

      <template v-slot:actions>
        <v-btn
          small
          outlined
          class="ml-2"
          color="blue"
          size="small"
          :disabled="loggingManualTime"
          @click="createManualTimeShow = false"
        >Cancel</v-btn>
        <v-btn
          small
          size="small"
          class="ml-2"
          color="secondary"
          variant="contained"
          :loading="loggingManualTime"
          :disabled="disableLogManualTimeBtn"
          @click="logManualTime()"
        >Log Manual Time</v-btn>
      </template>
    </app-dlg>
  </div>
</template>

<script>

import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import {
  getUUID,
  percentDisplay,
  hourDisplay,
  durationDisplay,
  arrSplice,
  validationRules, durationDisplayFull
} from "@/core/codeFunctions";
import AppDlg from "@/components/Shared/AppDlg";
import AppList from "@/components/Shared/AppList/AppList";
import {mapActions, mapGetters} from "vuex";
import AppDivider from "@/components/Shared/AppDivider/AppDivider";
import AppOutlinedChip from "@/components/Shared/AppOutlinedChip";
import VueApexCharts from 'vue-apexcharts'
import {
  addDays,
  differenceInDays,
  differenceInSeconds,
  endOfDay,
  endOfMonth,
  format,
  isMonday,
  isSameDay,
  isSameMonth,
  isSameYear,
  startOfDay,
  startOfMonth,
  subDays,
  subMonths,
  subWeeks,
  getSeconds,
} from "date-fns";
import AppScreenshotPreview from "@/components/Shared/Screenshots/AppScreenshotPreview";
import AppIcon from "@/components/Shared/AppIcon";
import {StatusMap} from "@/models/statusMap";
import AppClassificationDlg from "@/components/Shared/AppClassificationDlg";
import axios from "axios";
import AppNavBarTabs from "@/components/Shared/AppNavBarBody/AppNavBarTabs.vue";
import AppDeviceHardwareInfo from "@/components/Devices/AppDeviceHardwareInfo.vue";
import {de} from "date-fns/locale";

const calFmt = (date) => {
  try {
    return format(date, 'yyyy-MM-dd')
  } catch (e) {
    return null;
  }
}

export default {
  components: {
    AppDeviceHardwareInfo,
    AppNavBarTabs,
    AppClassificationDlg,
    AppIcon,
    AppScreenshotPreview,
    AppOutlinedChip,
    AppDivider,
    AppList,
    AppDlg,
    AppCentreLoader,
    apexChart: VueApexCharts
  },
  props: {},
  data() {
    return {
      hoursDisplay: hourDisplay,
      console,
      format,

      disablePersonalisedStats: false,
      startOfDay: startOfDay,
      validationRules: validationRules,
      createManualTimeShow: false,
      // /*isValidUrl,
      // screenshotsShown: true,
      statisticsShown: true,
      // topAppsShown: true,
      // timePerformanceShown: true,
      // breakdownShown: true,
      // hourDisplay,
      // percentDisplay,
      // durationDisplay,
      loading: true,
      loadingBreakdown: false,
      stats: {
        summary: null,
        topApps: [],
        breakdown: [],
        timePerformance: []
      },
      cards: [
        {text: 'Active Time', value: 'activeTime', description: 'Total time active'},
        {text: 'Target', value: 'ttt', description: 'Total target duration'},

        {text: 'Productive', value: 'ptt', description: 'Total time productive'},
        {text: 'Unproductive', value: 'utt', description: 'Total time unproductive'},
        {text: 'Neutral', value: 'ntt', description: 'Total time neutral'},
        {text: 'Idle', value: 'idleTime', description: 'Total idle duration'},

        // {text: 'Productive Normal', value: 'ptn', description: 'Time productive during working hours'},
        // {text: 'Productive Overtime', value: 'pto', description: 'Time productive outside of working hours'},
        {text: 'Productive Target %', value: 'productivityTarget', description: 'Total productivity vs total target'},


        // {text: 'Unproductive Normal', value: 'utn', description: 'Time unproductive during working hours'},
        // {
        //     text: 'Unproductive Overtime',
        //     value: 'uto',
        //     description: 'Time unproductive outside of working hours'
        // },
        //
        // {text: 'Neutral Normal', value: 'ntn', description: 'Time neutral during working hours'},
        // {text: 'Neutral Overtime', value: 'nto', description: 'Time neutral outside of working hours'},
        //
        //
        // {text: 'Productive Target %', value: 'productivityTarget', description: 'Total productivity vs total target'},
        // {text: 'Productive Normal Target %', value: 'productivityNormalTarget', description: 'Total productivity in working hours vs total target'},
        // {
        //     text: 'Productive Active %',
        //     value: 'productivityActive',
        //     description: 'Total productivity vs total active'
        // },
      ],
      topAppTableHeaders: [
        {text: 'Name', value: 'match'},
        {text: 'Total Duration', value: 'totalDuration'},
        {text: 'Label', value: 'label'},
      ],

      client: axios.create({
        baseURL: `https://${window.location.hostname}/employeeDashboard`,
        headers: {
          'site-id': this.$store.state.employeeDashboard.siteId,
          'device-id': this.$store.state.employeeDashboard.hwId
        }
      }),

      startingUp: false,
      authorized: true,

      employeeName: null,
      curDeviceId: null,
      employeeDevices: [],
      selectedTab: 0,
      scrollTop: 0,
      team: null,

      resetDtPicker: false,
      dateMenu: false,
      maxDate: (() => {return calFmt(new Date)})(),
      filters: [
        {
          title: "Today",
          cb: (title) => {
            return {
              title: title,
              start: startOfDay(new Date()),
              end: endOfDay(new Date()),
            }
          }
        },
        {
          title: "Yesterday",
          cb: (title) => {
            return {
              title: title,
              start: startOfDay(subDays(new Date(), 1)),
              end: endOfDay(subDays(new Date(), 1)),
            }
          }
        },
        {
          title: "This Week",
          cb: (title) => {
            let start = new Date()
            while (!isMonday(start))
              start = subDays(start, 1)
            return {
              title,
              start: startOfDay(start),
              end: new Date(),
            }
          }
        },
        {
          title: "Last Week",
          cb: (title) => {
            let start = subWeeks(new Date(), 1)
            while (!isMonday(start))
              start = subDays(start, 1)
            return {
              title,
              start: startOfDay(start),
              end: endOfDay(addDays(start, 6))
            }
          }
        },
        {
          title: "This Month",
          cb: (title) => {
            return {
              title,
              start: startOfDay(startOfMonth(new Date())),
              end: new Date(),
            }
          }
        },
        {
          title: "Last Month",
          cb: (title) => {
            return {
              title,
              start: startOfDay(startOfMonth(subMonths(new Date(), 1))),
              end: endOfMonth(subMonths(new Date(), 1)),
            }
          }
        },
      ],

      range: {
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        title: 'Today'
      },
      manualTimeStarting: false,
      staleTimes: [],

      staleTimeHeaders: [
        {text: 'Start', value: 'start'},
        {text: 'End', value: 'end'},
        {text: 'Duration', value: 'duration'},
      ],

      pendingApprovalHeaders: [
        {text: 'Reason', value: 'app'},
        {text: 'Start', value: 'start'},
        {text: 'End', value: 'end'},
        {text: 'Duration', value: 'duration'},
        {text: 'More', value: 'data-table-expand', align: 'center'},
      ],
      
      declinedHeaders: [
        {text: 'Reason', value: 'app'},
        {text: 'Start', value: 'start'},
        {text: 'End', value: 'end'},
        {text: 'Duration', value: 'duration'},
        {text: 'More', value: 'data-table-expand', align: 'center'},
      ],

      selectedStaleTimes: [],
      singleIdleRangeSelector: {
        startShown: false,
        endShown: false,
        start: format(new Date(), "HH:mm"),
        end: format(new Date(), "HH:mm"),
        min: format(new Date(), "HH:mm"),
        max: format(new Date(), "HH:mm")
      },
      selectedManualTimeOption: null,
      manualTimeOptions: [],
      loggingManualTime: false,
      employeeManualTimeMotivation: null,
      
      pendingManualTimes: [],
      declinedManualTimes: []
    }
  },
  watch: {
    // "$store.state.ref.dashboard.selectedRange.start": {
    //     immediate: true,
    //     handler(val) {
    //         this.refreshData()
    //     }
    // },
    // devicesWithAccessIds() {
    //     this.refreshData()
    // }

    resetDtPicker(val) {
      if (val)
        this.$nextTick(() => {
          this.resetDtPicker = false
        })
    },

    viewRange() {
      if (this.authorized) {
        this.refreshData()
        this.refreshManualTime()
      }
    },

    createManualTimeShow(val) {
      if (val && this.selectedStaleTimes.length === 1) {
        this.singleIdleRangeSelector.start = format(this.selectedStaleTimes.at(-1).start, "HH:mm")
        this.singleIdleRangeSelector.min = this.singleIdleRangeSelector.start
        this.singleIdleRangeSelector.end = format(this.selectedStaleTimes.at(-1).end, "HH:mm")
        this.singleIdleRangeSelector.max = this.singleIdleRangeSelector.end
      }

      this.selectedManualTimeOption = null
    }
  },
  mounted() {
    // this.refreshData();
    this.$vuetify.theme.dark = true;
    this.startup();
  },
  methods: {
    getItemClass(item) {
      // if (item.manualTimeMotivation)
      //   return ''
      
      if (item.manualTimeMotivation)
        return ''
      
      if (item.declinedReason)
        return ''
      
      // manualTimeMotivation
      
      return 'hide-expander'
    },
    
    getItemClassPending(item) {
      
      if (item.manualTimeMotivation)
        return ''
      
      if (item.members.length > 1)
        return ''
      
      // manualTimeMotivation
      
      return 'hide-expander'
    },
    
    addRemoveSelect(e, slot) {
      e.preventDefault();
      e.stopPropagation();

      if (this.selectedStaleTimes.includes(slot))
        arrSplice(this.selectedStaleTimes, item => item === slot)
      else
        this.selectedStaleTimes.push(slot)
    },

    rangeSelect(e, slot) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.selectedStaleTimes.length)
        this.selectedStaleTimes.push(slot)
      // Sort Selected Items
      const sortedItems = [...this.selectedStaleTimes].sort((a,b) => a.start > b.start ? 1 : -1)
      const allItems = [...this.staleTimes].sort((a,b) => a.start > b.start ? 1 : -1)
      if (sortedItems.at(-1).start < slot.start) {
        // filter all event from start to
        const newArr = allItems.filter((item, i, array) => i >= array.indexOf(sortedItems[0]) && i <= array.indexOf(slot))
        arrSplice(this.selectedStaleTimes, () => true)
        newArr.forEach(item => this.selectedStaleTimes.push(item))
      } else {
        const newArr = allItems.filter((item, i, array) => i <= array.indexOf(sortedItems.at(-1)) && i >= array.indexOf(slot))
        arrSplice(this.selectedStaleTimes, () => true)
        newArr.forEach(item => this.selectedStaleTimes.push(item))
      }
    },

    differenceInSeconds,
    hourDisplay,
    arrSplice,
    // ...mapActions(['gotoTeam', 'gotoDeviceSettings', 'gotoAppStats', 'gotoApp', 'updateSelections']),

    previousDay() {
      this.range.start = startOfDay(subDays(this.range.start, 1))
      this.range.end = endOfDay(this.range.start)
    },

    nextDay() {
      this.range.start = startOfDay(addDays(this.range.start, 1))
      this.range.end = endOfDay(this.range.start)
    },

    async logManualTime() {
      try {
        this.loggingManualTime = true
        let payload = this.selectedStaleTimes.length === 1
          ? [{
            match: this.selectedManualTimeOption.match,
            start: new Date(format(startOfDay(this.start), 'yyyy-MM-dd') + ` ${this.singleIdleRangeSelector.start}`),
            end: new Date(format(startOfDay(this.start), 'yyyy-MM-dd') + ` ${this.singleIdleRangeSelector.end}`)
          }]
          : this.selectedStaleTimes.map(obj => {
            return {
              match: this.selectedManualTimeOption.match,
              start: obj.start,
              end: obj.end
            }
          })

        const uuid = getUUID();

        const originalArr = JSON.parse(JSON.stringify(payload));
        const newPayloadArr = [];
        let currentTotalMillisecondsLogged = 0;

        const maxManualTimeAllowed = this.selectedManualTimeOption.manualTimeMaxTimeLimit * 1000;
        for (const entry of originalArr) {
          const startTimeMilliseconds = new Date(entry.start).getTime();
          const endTimeMilliseconds = new Date(entry.end).getTime();
          const testValue = currentTotalMillisecondsLogged + (endTimeMilliseconds - startTimeMilliseconds);
          if (maxManualTimeAllowed !== 0 && testValue > maxManualTimeAllowed) {
            entry.end = (new Date(startTimeMilliseconds + (maxManualTimeAllowed - currentTotalMillisecondsLogged))).toISOString();

            newPayloadArr.push({
              ...entry,
              manualTimeAutoApprove: this.selectedManualTimeOption.manualTimeAutoApprove,
              groupUuid: uuid,
              employeeManualTimeMotivation: this.employeeManualTimeMotivation
            })

            break;
          }

          newPayloadArr.push({
            ...entry,
            manualTimeAutoApprove: this.selectedManualTimeOption.manualTimeAutoApprove,
            groupUuid: uuid,
            employeeManualTimeMotivation: this.employeeManualTimeMotivation
          })

          currentTotalMillisecondsLogged += (testValue - currentTotalMillisecondsLogged);

        }

        const {data: logResult} = await this.client.post(
          `logManualTime`, {
            payload: newPayloadArr
          }
        )

        this.employeeManualTimeMotivation = null;
        this.selectedStaleTimes = [];
        this.createManualTimeShow = false;
        await this.refreshManualTime();
      } catch (e) {
        console.log(e)
      } finally {
        this.loggingManualTime = false
      }
    },

    setDates({start, end, title}) {
      this.range.title = title
      this.range.start = start;
      this.range.end = end;
      this.dateMenu = false
    },

    async startup() {
      this.startingUp = true;
      try {
        const {data} = await this.client.get(`startup`);
        this.employeeName = data.employeeName;
        this.curDeviceId = data.curDeviceId;
        this.employeeDevices = data.employeeDevices;
        this.team = data.team
        this.manualTimeOptions = data.manualTimeOptions;
        this.disablePersonalisedStats = data.disablePersonalisedStats
        if (this.disablePersonalisedStats)
          this.selectedTab = 1
        this.refreshData(true)
        this.refreshManualTime()
        this.authorized = true
      } catch (e) {
        console.log(e)
        this.authorized = false
      } finally {
        this.startingUp = false
      }
    },

    async refreshManualTime() {
      this.manualTimeStarting = true;
      try {
        const {data} = await this.client.post(`/manualStartup`, {start: this.start})

        this.staleTimes = data.staleTimes.map(stat => {
          stat.start = new Date(stat.start)
          stat.end = new Date(stat.end)
          stat.key = stat.start.getTime()
          return stat
        })
        
        this.pendingManualTimes = data.pendingManualTimes.map(v => ({
          ...v,
          start: new Date(v.start),
          end: new Date(v.end),
        }))
        this.declinedManualTimes = data.declinedManualTimes.map(v => ({
          ...v,
          start: new Date(v.start),
          end: new Date(v.end),
        }))
      } catch (e) {
        console.log(e)
        // this.authorized = false
      } finally {
        this.manualTimeStarting = false
      }
    },

    // async changeLabel(labelId) {
    //     this.selectedClassificationNewLabel = labelId
    //
    //     if (this.$store.state.historyPreference)
    //         this.saveClassificationLabelChangesConfirm(this.$store.state.historyPreference === 'history').catch(console.log)
    //     else {
    //         this.$refs.classificationDlg.showDlg()
    //     }
    // },
    //
    // async saveClassificationLabelChangesConfirm(updateHistorical = false) {
    //     const selectedClassification = this.selectedClassification
    //     const loadingMatch = selectedClassification.match
    //     const defaultLabel = this.selectedClassificationNewLabel
    //     try {
    //         this.loadingClassifications.push(selectedClassification.match)
    //         const editMap = new StatusMap({match: selectedClassification.match, defaultLabel: defaultLabel})
    //         const {_id} = await editMap.updateDefault(updateHistorical);
    //         selectedClassification.label = defaultLabel
    //         arrSplice(this.loadingClassifications, (match) => match === loadingMatch)
    //         if (updateHistorical)
    //             this.refreshData(false)
    //     } catch (e) {
    //         this.$snack.netWorkError()
    //         console.log(e)
    //         arrSplice(this.loadingClassifications, (match) => match === loadingMatch)
    //     }
    // },
    //
    // classificationMenuClicked(e, classification) {
    //     this.selectedClassification = classification;
    //     const params = e.target.getBoundingClientRect();
    //     this.showClassificationMenu = false
    //     this.$nextTick(() => {
    //         this.classificationX = (params.left + params.width) - 200
    //         this.classificationY = params.bottom
    //         this.showClassificationMenu = true
    //     })
    // },

    async refreshData(enableLoading = true) {
      try {
        this.loading = true;

        const {data} = await this.client.post( 'getEmployeeStats', {
          start: this.range.start,
          end: this.range.end,
        })

        const {summary, topApps, timePerformance} = data

        this.stats = {
          summary,
          topApps,
          breakdown: this.stats.breakdown || null,
          timePerformance
        }
        if (this.dateDays === 0)
          this.refreshBreakdownData(enableLoading)
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError();
      } finally {
        this.loading = false
      }
    },

    async refreshBreakdownData(enableLoading = true) {
      try {
        this.loadingBreakdown = true;
        const {data: breakdown} = await this.client.post( '/breakdown', {
          start: this.start,
          end: this.end,
        })

        let min = null;
        let max = null;

        const breakDownMapped = breakdown.map(app => {
          const appVal = {
            name: app.name,
            data: app.data.map(val => {
              if (!min || new Date(val.y[0]) < min)
                min = new Date(val.y[0])

              if (!max || new Date(val.y[1]) > max)
                max = new Date(val.y[1])

              let x;
              let fillColor;
              switch (val.x) {
                case -1: {
                  x = "Idle";
                  fillColor = '#9E9E9E'
                  break;
                }
                case -2: {
                  x = "Voice Call"
                  fillColor = '#CDDC39'
                  break;
                }
                case -3: {
                  x = "Manual Time"
                  fillColor = this.labelsRef[val.mtLabel].cssColor
                  break;
                }
                default: {
                  x = this.labelsRef[val.x].text
                  fillColor = this.labelsRef[val.x].cssColor
                }
              }

              return {
                label: val.x,
                x: x,
                y: val.y.map(dateStr => {
                  return new Date(dateStr).getTime()
                }),
                fromNo: val.fromNo || null,
                toNo: val.toNo || null,
                mtCreated: val.mtCreated ? format(new Date(val.mtCreated), "yyyy-MM-dd HH:mm") : null,
                mtApprovedDate: val.mtApprovedDate ? format(new Date(val.mtApprovedDate), "yyyy-MM-dd HH:mm") : null,
                mtLabel: val.mtLabel,
                fillColor: fillColor
              }
            })

          }
          return appVal
        })
        this.stats.breakdown = breakDownMapped
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError();
      } finally {
        if (enableLoading)
          this.loadingBreakdown = false
      }
    },

    doesManualTimeHaveADeclineReason(item) {
      if (item.manualTimeDetails)
        if (item.manualTimeDetails.declined)
          return true;
      return false;
    }
  },
  computed: {
    
    pendingManualTimesGrouped() {
      const values = new Map()
      // Group It Here
      
      for (const val of this.pendingManualTimes) {
        
        if (!values.has(val.groupUuid || val._id)) {
          values.set(val.groupUuid || val._id, {})
        }
        const ref = values.get(val.groupUuid || val._id)
        ref._id = val.groupUuid || val._id
        ref.hasMotivation = !!val.manualTimeMotivation
        
        if (ref.hasMotivation) {
          ref.motivation = val.manualTimeMotivation
        }
        
        ref.hasDeclinedReason = !!val.declinedReason
        if (ref.hasDeclinedReason) {
          ref.declinedReason = val.declinedReason
        }
        ref.app = val.match
        ref.start = !ref.start ? new Date(val.start) : (ref.start < new Date(val.start) ? ref.start : new Date(val.start))
        ref.end = !ref.end ? new Date(val.end) : (ref.end > new Date(val.end) ? ref.end : new Date(val.end))
        ref.duration = (ref.duration || 0) + val.duration
        ref.employeeId = val.employeeId;
        
        if (!ref.members)
          ref.members = []
        ref.members.push(val)
      }
      
      
      return [...values.values()]
    
    },
    
    declinedManualTimesGrouped() {
      const values = new Map()
      // Group It Here
      
      for (const val of this.declinedManualTimes) {
        
        if (!values.has(val.groupUuid || val._id)) {
          values.set(val.groupUuid || val._id, {})
        }
        const ref = values.get(val.groupUuid || val._id)
        ref._id = val.groupUuid || val._id
        ref.hasMotivation = !!val.manualTimeMotivation
        
        if (ref.hasMotivation) {
          ref.motivation = val.manualTimeMotivation
        }
        
        ref.hasDeclinedReason = !!val.declinedReason
        if (ref.hasDeclinedReason) {
          ref.declinedReason = val.declinedReason
        }
        ref.app = val.match
        ref.start = !ref.start ? new Date(val.start) : (ref.start < new Date(val.start) ? ref.start : new Date(val.start))
        ref.end = !ref.end ? new Date(val.end) : (ref.end > new Date(val.end) ? ref.end : new Date(val.end))
        ref.duration = (ref.duration || 0) + val.duration
        ref.employeeId = val.employeeId;
        
        if (!ref.members)
          ref.members = []
        ref.members.push(val)
      }
      
      
      return [...values.values()]
      
    },
    
    tabs() {
      
      const tabs = []
      if (!this.disablePersonalisedStats) tabs.push({key: 0, text: 'Stats'})
      tabs.push({key: 1, text: 'Log Time'})
      tabs.push({key: 2, text: `Pending${this.pendingManualTimes.length ? `(${this.pendingManualTimesGrouped.length})` : ''}`})
      tabs.push({key: 3, text: `Declined${this.declinedManualTimes.length ? `(${this.declinedManualTimesGrouped.length})` : ''}`})
      
      console.log(this.pendingManualTimes, this.declinedManualTimes)
    
      return tabs
    },

    isRangeStartToday() {
      return isSameDay(this.range.start, new Date())
    },

    de() {
      return de
    },

    curDevice() {
      return this.employeeDevices.find(device => device._id === this.curDeviceId)
    },

    viewRange() {
      return {
        start: this.range.start,
        end: this.range.end
      }
    },

    dateTitle() {
      // TODO Add Here
      // if (this.range.title)
      //     return this.range.title
      if (!isSameYear(this.range.start, this.range.end))
        return `${format(this.range.start,'dd MMM yyyy')} - ${format(this.range.end,'dd MMM yyyy')}`
      if (!isSameMonth(this.range.start, this.range.end))
        return `${format(this.range.start,'dd MMM')} - ${format(this.range.end,'dd MMM yyyy')}`
      if (!isSameDay(this.range.start, this.range.end))
        return `${format(this.range.start,'dd')} - ${format(this.range.end,'dd MMM yyyy')}`
      return format(this.range.end,'dd MMM yyyy')
    },
    dates: {
      get() {
        return isSameDay(this.range.start, this.range.end) ? [calFmt(this.range.start, 'yyyy-MM-dd')] : [calFmt(this.range.start, 'yyyy-MM-dd'), calFmt(this.range.end, 'yyyy-MM-dd')]
      },
      set(dates) {
        if (!dates || !dates.length) {
          this.range.start = new Date();
          this.range.end = new Date();
          return;
        }
        if (dates.length === 1) {
          this.range.start = new Date(dates[0]);
          this.range.end = new Date(dates[0]);
        } else {
          const dt1 = new Date(dates[0]);
          const dt2 = new Date(dates[1]);
          this.range.start = dt1 < dt2 ? dt1 : dt2;
          this.range.end = dt1 < dt2 ? dt2 : dt1;
        }
      }
    },

    ...mapGetters(['labelsRef', 'labels']),

    dateDays() {
      return differenceInDays(this.start, this.end)
    },

    timePerformanceChartData() {

      const timeNames = this.stats.timePerformance.map(obj => {
        // return obj._id % 1800 === 0 ? obj.name : ''
        return obj.name
      })

      const neutralSeries = this.stats.timePerformance.map(obj => obj.ntt)
      const productiveSeries = this.stats.timePerformance.map(obj => obj.ptt)
      const unproductiveSeries = this.stats.timePerformance.map(obj => obj.utt)

      const series = [
        {
          name: 'Neutral',
          data: neutralSeries,
          fillColor: this.labelsRef[0].cssColor
        }, {
          name: 'Productive',
          data: productiveSeries,
          fillColor: this.labelsRef[1].cssColor
        }, {
          name: 'Unproductive',
          data: unproductiveSeries,
          fillColor: this.labelsRef[2].cssColor
        }
      ]

      const dummySeries = [{
        name: "Desktops",
        data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
      }]

      const chartOptions = {
        chart: {
          height: 350,
          type: 'line',
          zoom: {enabled: false},
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          colors: [this.labelsRef[0].cssColor, this.labelsRef[1].cssColor, this.labelsRef[2].cssColor],
          dashArray: [0, 0, 0],
          width: 2
        },
        grid: {
          show: true,
          borderColor: 'var(--v-primary-base)',
          strokeDashArray: 0,
          position: 'back',
          yaxis: {
            lines: {
              show: false
            }
          },
        },
        xaxis: {
          categories: timeNames,
          labels: {
            rotate: -60,
            rotateAlways: true,
            style: {
              colors: timeNames.map(() => '#fff'),
            },
          },
          axisBorder: {
            show: true,
            color: 'var(--v-primary-base)',
            height: 1,
          },
        },
        tooltip: {
          enabled: false,
          theme: 'dark',
          y: {
            formatter: function (val) {
              return durationDisplay(val)
            },
            title: {
              formatter: (seriesName) => seriesName,
            },
          },
        },
        yaxis: {
          show: true,
          title: {
            text: 'Activity'
          },
          labels: {
            show: false,
          },
        },
        legend: {
          markers: {
            fillColors: [this.labelsRef[0].cssColor, this.labelsRef[1].cssColor, this.labelsRef[2].cssColor]
          },
          labels: {
            colors: ['#fff']
          },
        },
        colors: [this.labelsRef[0].cssColor, this.labelsRef[1].cssColor, this.labelsRef[2].cssColor],
      }

      return {
        series,
        chartOptions,
      }
    },

    breakdownChartData() {
      const vm = this;
      const chartOptions = {
        grid: {
          show: false,},
        yaxis: {
          labels: {
            show: true,
            align: 'right',
            style: {
              colors: ['#FFF'],
              fontSize: '14px',
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            },
          },
        },
        chart: {
          height: 350,
          type: 'rangeBar',
          animations: {
            enabled: false
          },
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '85%',
            rangeBarGroupRows: true
          }
        },
        fill: {
          type: 'solid'
        },
        xaxis: {
          type: 'datetime',
          axisBorder: {
            show: true,
            color: 'var(--v-primary-base)',
            height: 1,
          },
          labels: {
            style: {
              colors: ['#fff'],
            },
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM 'yy",
              day: 'dd MMM',
              hour: 'HH:mm',
            },
          },
        },
        legend: {
          position: 'right',
          labels: {
            colors: ['#FFF']
          },
          markers: {
            fillColors: this.stats.breakdown.map(app => {
              return app.data[0].label === -1
                ? '#9E9E9E'
                : (
                  app.name === 'Voice Call'
                    ? '#CDDC39'
                    : this.labelsRef[app.data[0].mtLabel].cssColor
                )
            }),
          },
        },
        tooltip: {
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            const item = vm.stats.breakdown[seriesIndex]
            const start = item.data[dataPointIndex].y[0]
            const end = item.data[dataPointIndex].y[1]
            return`

<div class="pa-2" style="color: white; background: black">
<div class="caption">${item.name}</div>
${item.data[dataPointIndex].fromNo ? `<div class="caption">From: ${item.data[dataPointIndex].fromNo}</div>` : ''}
${item.data[dataPointIndex].toNo ? `<div class="caption">To: ${item.data[dataPointIndex].toNo}</div>` : ''}
<div class="body-1 text-right">${durationDisplay(Math.floor((end - start) / 1000))}</div>
</div>
`
          }
        }
      }
      return {
        chartOptions,
        series: this.stats.breakdown
      }
    },

    productivityChartData() {

      const totalTime = this.stats.summary.ptt
        + this.stats.summary.ntt
        + this.stats.summary.utt
        + this.stats.summary.idleTime

      const series = [
        {
          label: 'Productive',
          val: Math.floor((this.stats.summary.ptt / totalTime) * 100) > 0 ? Math.floor((this.stats.summary.ptt / totalTime) * 100) || 0.2 : 0.2,
          color: this.labelsRef[1].cssColor
        },
        {
          label: 'Neutral',
          val: Math.floor((this.stats.summary.ntt / totalTime) * 100) > 0 ? Math.floor((this.stats.summary.ntt / totalTime) * 100) || 0.2 : 0.2,
          color: this.labelsRef[0].cssColor
        },
        {
          label: 'Unproductive',
          val: Math.floor((this.stats.summary.utt / totalTime) * 100) > 0 ? Math.floor((this.stats.summary.utt / totalTime) * 100) || 0.2 : 0.2,
          color: this.labelsRef[2].cssColor
        },
        {
          label: 'Idle',
          val: Math.floor((this.stats.summary.idleTime / totalTime) * 100) > 0 ? Math.floor((this.stats.summary.idleTime / totalTime) * 100) || 0.2 : 0.2,
          color: '#607D8B'
        },

      ]

      const seriesNames = series.map(obj => obj.label)
      const seriesData = series.map(obj => obj.val)
      const seriesColors = series.map(obj => obj.color)

      const chartOptions = {
        chart: {
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            inverseOrder: true,
            hollow: {
              margin: 10,
              size: '46%',
              background: 'transparent',
            },
            track: {
              show: false,
            },
            startAngle: -180,
            endAngle: 180
          },
        },
        fill: {
          type: 'solid',
          colors: seriesColors
        },
        stroke: {
          lineCap: 'round'
        },
        // series: seriesData,
        labels: seriesNames,
        legend: {
          show: true,
          floating: false,
          position: 'top',
          // offsetX: 70,
          // offsetY: 208,
          labels: {
            colors: ['#fff']
          },
          markers: {
            fillColors: seriesColors
          }
        },
        // fill: {
        //     opacity: 1,
        //     colors: seriesColors
        // },

        // labels: seriesNames,
        // grid: {
        //     show: false,
        // },
        // dataLabels: {
        //     enabled: false,
        //     background: {
        //         enabled: false,},
        //     style: {colors: ['#fff']},
        //     dropShadow: {enabled: false,},
        //     formatter: function (val, opts) {
        //         return hourDisplay(seriesData[opts.seriesIndex])
        //     },
        // },
        // stroke: {
        //     opacity: 0,
        //     colors: seriesColors,
        //     width: 0
        // },

        // chart: {
        //     type: 'polarArea',
        // },
        // legend: {show: false,},
        // yaxis: {show: false},
        // plotOptions: {
        //     polarArea: {
        //         rings: {
        //             strokeWidth: 0
        //         },
        //         spokes: {
        //             strokeWidth: 0
        //         },
        //     }
        // },
        // tooltip: {
        //     fillSeriesColor: true,
        //     custom: function({series, seriesIndex, dataPointIndex, w}) {
        //         console.log({series, seriesIndex, dataPointIndex, w})
        //         return` <div class="pa-1"> <div class="caption">${seriesNames[seriesIndex]}</div> <div class="body-1 text-right">${durationDisplay(seriesData[seriesIndex])}</div> </div> `
        //     }
        // },
        // theme: {
        //     mode: 'dark',}
      }
      return {
        seriesData: seriesData,
        chartOptions,
      }
    },

    topAppsChartData() {

      const series = [...this.stats.topApps].sort((a, b) => a.label > b.label ? 1 : -1)

      const seriesNames = series.map(obj => obj.match)
      const seriesData = series.map(obj => obj.totalDuration)
      const seriesColors = series.map(obj => this.labelsRef[obj.label].cssColor)

      const chartOptions = {
        labels: seriesNames,
        grid: {
          show: false,
        },
        dataLabels: {
          enabled: false,
          background: {
            enabled: false,
          },
          style: {colors: ['#fff']},
          dropShadow: {enabled: false,},
          formatter: function (val, opts) {
            return hourDisplay(seriesData[opts.seriesIndex])
          },
        },
        stroke: {
          opacity: 0,
          colors: ['#000'],
          width: 0
        },
        fill: {
          opacity: 1,
          colors: seriesColors
        },
        // chart: {
        //     type: 'pie',
        // },
        legend: {show: false,},
        yaxis: {show: false},
        plotOptions: {

        },
        tooltip: {
          fillSeriesColor: true,
          custom: function ({series, seriesIndex, dataPointIndex, w}) {
            return ` <div class="pa-1"> <div class="caption">${seriesNames[seriesIndex]}</div> <div class="body-1 text-right">${durationDisplay(seriesData[seriesIndex])}</div> </div> `
          }
        },
        // theme: {
        //     mode: 'dark',}
      }
      return {
        seriesData,
        chartOptions,
      }
    },

    shownCards() {
      return this.cards.map(card => {
        const key = card.value
        return {
          key,
          info: card,
          val: (() => {
            switch (key) {
              case 'productivityTarget':
                return percentDisplay(this.stats.summary[key] || 0)
              case 'productivityActive':
                return percentDisplay(this.stats.summary[key])
              case 'productivityNormalTarget':
                return percentDisplay(this.stats.summary[key])
              default:
                return durationDisplayFull(this.stats.summary[key])
            }
          })(),
          // valDesc: (() => {
          //     if (['productivityTarget', 'productivityActive'].includes(key))
          //         return null
          //     return hourDisplay(this.stats.summary[key])
          // })(),
        }
      })
    },
    //
//         team() {
//             return this.teamsRef[this.employee.teamId]
//         },
//
//         devices() {
//             return this.devicesByEmployee[this.$store.state.ref.employeeStats.selectedEmployee];
//         },
//
//         employee() {
//             return this.employeesRef[this.$store.state.ref.employeeStats.selectedEmployee];
//         },
    start() {
      return this.range.start
    },
    end() {
      return this.range.end
    },
    // dateTitle() {
    //     // TODO Add Here
    //     // if (this.range.title)
    //     //     return this.range.title
    //     if (!isSameYear(this.range.start, this.range.end))
    //         return `${format(this.range.start,'dd MMM yyyy')} - ${format(this.range.end,'dd MMM yyyy')}`
    //     if (!isSameMonth(this.range.start, this.range.end))
    //         return `${format(this.range.start,'dd MMM')} - ${format(this.range.end,'dd MMM yyyy')}`
    //     if (!isSameDay(this.range.start, this.range.end))
    //         return `${format(this.range.start,'dd')} - ${format(this.range.end,'dd MMM yyyy')}`
    //     return format(this.range.end,'dd MMM yyyy')
    // },

    disableLogManualTimeBtn() {
      const requireMotivation = this.selectedManualTimeOption ? this.selectedManualTimeOption.manualTimeMotivation : false;
      return !this.selectedManualTimeOption || this.loggingManualTime || (requireMotivation ? !this.employeeManualTimeMotivation : false);
    }
  },
}
</script>

<style scoped>
.time-sector{
  background: rgba(50,50,50);
  height: 40px;
  position: absolute;
  white-space: nowrap;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.time-sector:hover{
  background: rgba(70,70,70);
}

.time-sector.selected{
  background: var(--v-primary-base);
}
.time-sector.selected:hover{
  background: var(--v-primary-lighten1);
}


</style>